// view-nav-desktop.js — 桌面端导航：顶部聊天按钮
// 侧边工具栏快捷按钮（收藏/云盘/回收站/音乐/待办/灵感/日记）及收藏拖拽已迁至 workspace-toolbar.js；
// 本模块仅保留顶部聊天按钮绑定与面板状态同步。

// 幂等：聊天按钮为模板内元素，跨 chunk 模板重注入后会替换为新元素，
// 故用元素级标志（_navBound）保证新元素可重新绑定、同 chunk 切换不重复绑定。
var _panelStateBound = false; // 面板显隐监听绑在 document 上（持久），用模块级标志只绑一次

export function initViewNavDesktop() {
  // ===== 顶部聊天按钮点击（top-header） =====
  var topChatBtn = document.querySelector('.top-header-chat-btn[data-action="chat"]');
  if (topChatBtn && !topChatBtn._navBound) {
    topChatBtn._navBound = true;
    topChatBtn.addEventListener('click', function(e) {
      e.preventDefault();
      import('@modules/desktop-chat-panel.js').then(function(mod) {
        if (mod.isDesktopChatPanelOpen && mod.isDesktopChatPanelOpen()) {
          mod.closeDesktopChatPanel();
        } else {
          mod.openDesktopChatPanel();
        }
      });
    });
  }

  // 面板内部关闭（如返回键）时同步按钮状态：始终查询当前聊天按钮，避免闭包引用旧元素
  if (!_panelStateBound) {
    _panelStateBound = true;
    document.addEventListener('xiaque:panel-hidden', function() {
      var b = document.querySelector('.top-header-chat-btn[data-action="chat"]');
      if (b) b.classList.remove('active');
    });
    document.addEventListener('xiaque:panel-shown', function() {
      var b = document.querySelector('.top-header-chat-btn[data-action="chat"]');
      if (b) b.classList.add('active');
    });
  }
}